import i18n from "l10n";
import Backbone from "backboneAdapter";
import "traits/google-analytics";
import template from "templates/confirm.registration.htm";

const ConfirmRegistrationView = Backbone.View.extend({
    el: '#page-main-content',
    initialize: function (options) {
        this.render();
        const registrationToken = options["registrationToken"];
        const formValues = {
            registrationToken: registrationToken
        };

        const regMessage = $("#registration-message");
        this.confirm(formValues, regMessage);
    },
    render(){
        this.$el.html(template);
        this.$('[data-i18n]').i18n();
    },
    async confirm(formValues, regMessage) {
        try{
            await $.ajaxDefaultQ({
                url: '/CampaignCloud/logout',
                type: 'POST',
                dataType: "json",
                headers: {'X-CSRF-TOKEN': window.csrf}
            });
        }finally {
            try {
                const confirmRegistrationResp = await $.ajaxDefaultQ({
                    url: '/CampaignCloud/Registration/ConfirmRegistration',
                    type: 'POST',
                    dataType: "json",
                    data: formValues
                });
                if (confirmRegistrationResp.status === "success") {
                    this.setValidClass(regMessage);
                    $("#registration-icon").addClass("icon-thumbs-up");
                    regMessage.text(i18n.t("confirmregistration.confirmsuccess"));
                    setTimeout(() => {
                        this.trigger("navigation", "");
                    }, 3000);
                } else if (confirmRegistrationResp.status === "notfound") {
                    this.setInvalidClass(regMessage);
                    $("#registration-icon").addClass("icon-warning");
                    regMessage.text(i18n.t("confirmregistration.notfound"))
                    .append(`<a href='Login.htm#Registration'>${i18n.t("confirmregistration.registerlink")} </a>`);
                } else {
                    this.setInvalidClass(regMessage);
                    $("#registration-icon").addClass("icon-warning");
                    regMessage.text(i18n.t("confirmregistration.errormessage"));
                }
            } catch (e) {
                console.error(e);
                regMessage.text(i18n.t("confirmregistration.errormessage"));
            }
        }
    },
    setInvalidClass: function (regMessage) {
        regMessage.removeClass("uploadsuccess");
        regMessage.addClass("invalidmessage");
    },
    setValidClass: function (regMessage) {
        regMessage.removeClass("invalidmessage");
        regMessage.addClass("uploadsuccess");
    }
});

export {ConfirmRegistrationView as default};